import React from "react";
import dayjs from "dayjs";
import i18n from "i18next";
import { useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import devDebug from "../Helpers/debug";
import { safeRemove } from "../Helpers/safeStorage";
import { useTenderStrategyStore } from "../Stores/tenderStrategyStore";
import { Button } from "reactstrap";
import TendersClubLogo from "../Components/tendersClubLogo";
import { useNavigate } from "react-router-dom";
import ScreenSpinner from "../Components/ScreenSpinner";
import { useDefaultStrategyStore } from "../Stores/defaultStrategyStore";
import { useComponentsStore } from "../Stores/componentsStore";
import { useTenderAwardsSearchStore } from "../Stores/tenderAwardsSearch";
import { useMapsStore } from "../Stores/mapsStore";
import { useDashboardStore } from "../Stores/dashboardStore";
import { useTabStore } from "../Stores/tabStore";
import { useTenderAwardsStore } from "../Stores/tenderAwardsStore";
import { useTenderSearchStore } from "../Stores/tenderSearch";
import { useCPVStore } from "../Stores/cpvStore";
import { useListUsersStore } from "../Stores/listUsersStore";
import { useCompaniesSearchStore } from "../Stores/companiesSearchStore";
import { useRegisterStore } from "../Stores/registerStore";
import { useVademecumStore } from "../Stores/vademecumStore";
import { useTaskManagementStore } from "../Stores/taskManagementStore";
import { useAuthStore } from "../Stores/authStore";
import { useAlboFornitoriStore } from "../Stores/alboFornitoriStore";
import { useViewSupplierListNotice } from "../Stores/viewSupplierListNoticeStore";
import { useVersionChangeStore } from "../Stores/versionChangeStore";
import { useAllStoresHydrated } from "./useAllStoresHydrated";
import useRefreshOnVersionChange from "../Layout/refreshOnVersionChange/useRefreshOnVersionChange";

const tenderSearchAdminTabKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_ADMIN_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderSearchTabKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;
const dashboardTabKey = `${import.meta.env.VITE_DASHBOARD_TAB_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderSearchTableSettingsAdminKey = `${import.meta.env.VITE_TENDER_SEARCH_TABLE_ADMIN_SETTINGS_KEY}_${
  import.meta.env.VITE_VERSION
}`;
const tenderSearchTabAdminKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_ADMIN_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderSearchTableSettingsKey = `${import.meta.env.VITE_TENDER_SEARCH_TABLE_SETTINGS_KEY}_${
  import.meta.env.VITE_VERSION
}`;
const tenderAwardsSearchTableSettingsKey = `${import.meta.env.VITE_AWARDS_SEARCH_TABLE_SETTINGS_KEY}_${
  import.meta.env.VITE_VERSION
}`;
const colourSchemeKey = `${import.meta.env.VITE_COLOR_SCHEME_KEY}_${import.meta.env.VITE_VERSION}`;
const viewTenderTabStateKey = `${import.meta.env.VITE_VIEW_TENDER_TAB_STATE_KEY}_${import.meta.env.VITE_VERSION}`;
const CPVWeightLocalStorageKey = `${import.meta.env.VITE_VIEW_TENDER_ANALYTICS_CPV_WEIGHT_KEY}_${
  import.meta.env.VITE_VERSION
}`;
const NUTWeightLocalStorageKey = `${import.meta.env.VITE_VIEW_TENDER_ANALYTICS_NUTS_WEIGHT_KEY}_${
  import.meta.env.VITE_VERSION
}`;

let AuthContext = React.createContext();
export function useAuth() {
  return React.useContext(AuthContext);
}
// axios.defaults.withCredentials = false;
// axios.defaults.credentials = "omit";
axios.defaults.baseURL = `${import.meta.env.VITE_BASEURL}/`;

const api = axios.create({
  baseURL: `${import.meta.env.VITE_BASEURL}/`,
});

const authService = {
  isAuthenticated: false,
  signin(callback) {
    authService.isAuthenticated = true;
    setTimeout(callback, 100);
  },
  // signout(callback) {
  //   authService.isAuthenticated = false;
  //   setTimeout(callback, 100);
  // },
};

const apiService = {
  //url -> the endpoint
  //signal -> for request cancellation / interruption if navigating away
  //successFn -> whatever needs to happen on success, gets resp & data object
  //errAlertFn -> the hook from alerter context to show errors
  //errMsg -> the message to include for the alerter
  //errFn -> wrap-up function to execute on error, gets data object
  //data -> the data object, can be anything, used for payloads also
  axiosGET(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api.defaults.headers.common["Authorization"] = `JWT ${useAuthStore.getState().accessToken}`;
    api
      .get(url, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosUnauthGET(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    axios
      .get(url, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosUnauthPOST(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    axios
      .post(url, data.payload, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosPOST(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .post(url, data.payload, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosPOSTFormData(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .post(url, data.formData, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosPATCHFormData(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .patch(url, data.formData, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosPATCH(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .patch(url, data.payload, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosDELETE(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .delete(url, data.payload, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
  axiosOPTIONS(url, signal, successFn, errAlertFn, errMsg, errFn, data) {
    api
      .options(url, data.payload, {
        signal: signal,
      })
      .then((resp) => {
        successFn(resp.data, data);
      })
      .catch(function (err) {
        const canceled = errAlertFn(errMsg, err, data.section ? data.section : null, data.suppressError);
        if (errFn) {
          if (!canceled) {
            errFn(err, data);
          }
        }
      });
  },
};

export const removeAllLocalState = (removeAuth) => {
  devDebug("removeAllLocalState -> setting unsaved strategy to 0, removeAuth is: ", removeAuth);

  if (removeAuth) {
    useAuthStore.getState().resetState();
  } else {
    devDebug("removeAllLocalState -> not removing auth information");
  }

  useAlboFornitoriStore.getState().resetState();
  useCompaniesSearchStore.getState().resetState();
  // useComponentsStore.getState().resetState();
  useCPVStore.getState().resetState();
  useDashboardStore.getState().resetState();
  useDefaultStrategyStore.getState().resetState();
  useListUsersStore.getState().resetState();
  useMapsStore.getState().resetState();
  useRegisterStore.getState().resetState();
  useTabStore.getState().resetState();
  useTaskManagementStore.getState().resetState();
  useTenderAwardsSearchStore.getState().resetState();
  useTenderAwardsStore.getState().resetState();
  useTenderSearchStore.getState().resetState();
  useTenderStrategyStore.getState().resetState();
  useVademecumStore.getState().resetState();
  useViewSupplierListNotice.getState().resetState();

  // Auto-discover and remove all versioned raw-localStorage keys
  const version = import.meta.env.VITE_VERSION;
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith(`_${version}`)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => safeRemove(key));

  for (var i = 1; i < 99999; i++) {
    window.clearInterval(i);
  }
};

export function AuthProvider({ children }) {
  let [alert, setAlert] = React.useState({});
  let [unauthorised, setUnauthorised] = React.useState(false);
  let [forbidden, setForbidden] = React.useState(false);
  let [showAlert, setShowAlert] = React.useState(false);
  const [isDark] = useComponentsStore((state) => [state.isDark]);
  const navigate = useNavigate();

  const [jwtRefreshed] = useAuthStore((state) => [state.jwtRefreshed]);

  let accessTokenTimeoutID;

  const signout = () => {
    navigate(`/${i18n.language.slice(0, 2)}/login`);
    setTimeout(() => {
      stopAccessTokenTimer();
      removeAllLocalState(true); //true means auth data also gets deleted
    }, [100]);
  };

  const startAccessTokenTimer = () => {
    const setJWTRefreshed = useAuthStore.getState().setJWTRefreshed;

    if (!useAuthStore.getState().accessToken) {
      devDebug("Auth -> No tokens found, returning");
      signout();
      window.location.replace(`/${i18n.language.slice(0, 2)}/login`);
      return;
    }

    let jwtToken;
    try {
      jwtToken = JSON.parse(window.atob(useAuthStore.getState().accessToken.split(".")[1]));
    } catch (err) {
      devDebug("Auth -> Failed to decode JWT, signing out", err);
      signout();
      return;
    }

    let expiry = dayjs.unix(jwtToken.exp);
    let now = dayjs();
    let secondsUntilExpiry = expiry.diff(now, "seconds");
    devDebug("secondsUntilExpiry: ", secondsUntilExpiry);
    //let secondsUntilRefresh = 240;
    let secondsUntilRefresh = 30;

    let secondsLeftUntilRefreshNeeded = (secondsUntilRefresh - secondsUntilExpiry) * -1;

    devDebug("secondsLeftUntilRefreshNeeded: ", secondsLeftUntilRefreshNeeded);

    if (secondsLeftUntilRefreshNeeded < 120) {
      devDebug("Auth -> Token expired, refreshing");
      getAccessToken();
    } else {
      devDebug(
        `Auth -> accessTokenSuccess -> Setting JWT refreshed to true, as token is still valid for another ${secondsLeftUntilRefreshNeeded} seconds`
      );
      api.defaults.headers.common["Authorization"] = `JWT ${useAuthStore.getState().accessToken}`;
      setJWTRefreshed(true);
      accessTokenTimeoutID = setTimeout(getAccessToken, secondsLeftUntilRefreshNeeded * 1000);
    }
  };

  const getAccessTokenSuccess = (resp) => {
    //optional data attribute available
    refreshTokenRetryCount = 0;
    const setJWTRefreshed = useAuthStore.getState().setJWTRefreshed;
    useAuthStore.getState().setAccessToken(resp.access);
    useAuthStore.getState().setRefreshToken(resp.refresh);
    startAccessTokenTimer();
    devDebug("Auth -> getAccessTokenSuccess -> Setting JWT refreshed to true, with token: ", resp.access);
    setJWTRefreshed(true);
  };
  let refreshTokenRetryCount = 0;
  const getAccessTokenError = () => {
    refreshTokenRetryCount++;
    if (refreshTokenRetryCount < 3) {
      devDebug(`Auth -> Token refresh failed, retrying (${refreshTokenRetryCount}/3)`);
      getAccessToken();
    } else {
      devDebug("Auth -> Token refresh failed after retries, signing out");
      refreshTokenRetryCount = 0;
      signout();
    }
  };

  const newErrorHandler = (msg, err, section, suppressError) => {
    devDebug(`Alerter -> Error Handler invoked ${section ? `for ${section}` : ""}`);
    if (err.name === "CanceledError") {
      devDebug("Alerter -> Request was cancelled: " + msg);
      return true;
    } else {
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        devDebug(`Alerter -> Error with response received, msg: ${JSON.stringify(msg)}`);
        devDebug(`Alerter -> data: ${JSON.stringify(err.response.data)}`);
        devDebug(`Alerter -> data: ${JSON.stringify(err.response.data)}`);
        devDebug(`Alerter -> status: ${JSON.stringify(err.response.status)}`);
        devDebug(`Alerter -> headers: ${JSON.stringify(err.response.headers)}`);

        // err.response.data.detail = err.response.data.detail === "Given token not valid for any token type"
        // ? t("You are not authorised to view this page")
        // : e,

        if (err.response.status === 401) {
          devDebug("Alerter -> Unauthorised, deleting all local state");
          removeAllLocalState(true); //true means auth data also gets deleted
          if (!window.location.toString().includes("login")) {
            window.location.replace("/login");
            return;
          }
        }

        if (err.response.status === 403) {
          setForbidden(true);
        }

        if (err.response.status === suppressError) {
          devDebug("Alerter -> suppressing error: ", suppressError);
          return;
        }

        let errStr = "";
        if (typeof err.response.data === "object") {
          errorString(err.response.data);
          function errorString(errObj) {
            for (let key of Object.keys(errObj)) {
              if (typeof errObj[key] === "string") {
                errStr += errObj[key];
              } else if (Array.isArray(errObj[key])) {
                for (let e of errObj[key]) {
                  errStr += `${key}: ${e} | `;
                }
              } else {
                errorString(errObj[key]);
              }
            }
          }
          errStr = errStr.slice(0, -2);
        } else {
          errStr = err.response.data.toString();
          if (errStr.length > 150) {
            errStr = `${errStr.substring(0, 150)}...`;
          }
          if (errStr.includes("<!DOCTYPE html>")) {
            errStr = i18n.t("Resource not found");
          }
        }

        show({
          message: i18n.t(msg, {
            error: errStr,
          }),
          type: "alert_warning",
        });
      } else if (err.request) {
        devDebug(`Alerter -> Error in request: No / incomplete data from server received, err: ${err}`);
        show({
          message: i18n.t("There was a connection error"),
          type: "alert_warning",
        });
      } else {
        devDebug(`Alerter -> Unhandled exception, msg: ${msg}, error: ${err.toString() ? err.toString() : err}`);
        if (typeof err === "object") {
          let errStr = err.toString();
          if (errStr.length > 150) {
            errStr = `${errStr.substring(0, 150)}...`;
          }
          show({
            message: i18n.t("There was an unknown error", {
              error: errStr,
            }),
            type: "alert_warning",
          });
        } else {
          show({
            message: i18n.t("There was an unknown error"),
            type: "alert_warning",
          });
        }
      }
    }
  };

  const getAccessToken = () => {
    if (useAuthStore.getState().refreshToken) {
      const controller = new AbortController();
      return apiService.axiosUnauthPOST(
        `auth/token/refresh/`, //endpoint
        controller.signal, //signal
        getAccessTokenSuccess, //successFn
        newErrorHandler, //error AlerterFn
        "Error refreshing access token", //error message
        getAccessTokenError, //errorFn (gets error back)
        { payload: { refresh: useAuthStore.getState().refreshToken } } //data (gets handed back to success fn)
      );
    }
  };

  React.useEffect(() => {
    if (useAuthStore.getState().accessToken) {
      devDebug("Auth -> Found an accessToken, starting refresh timer: ", useAuthStore.getState().accessToken);
      startAccessTokenTimer();
    } else {
      devDebug("Auth -> No accessToken found, setting JWT refreshed to true");
      useAuthStore.getState().setJWTRefreshed(true);
    }
  }, []);

  let signin = () => {
    api.defaults.headers.common["Authorization"] = `JWT ${useAuthStore.getState().accessToken}`;
    return setTimeout(() => {
      authService.signin(() => {
        startAccessTokenTimer();
      });
    }, 10);
  };

  // let setAuthorisation = () => {
  //   api.defaults.headers.common["Authorization"] = `JWT ${useAuthStore.getState().accessToken}`;
  // };

  const stopAccessTokenTimer = () => {
    clearTimeout(accessTokenTimeoutID);
  };

  let show = (alert) => {
    setAlert(alert);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 5000);
  };

  let hide = () => {
    setAlert(null);
    setShowAlert(false);
  };

  let value = {
    apiService,
    signin,
    signout,
    newErrorHandler,
    alert,
    showAlert,
    show,
    hide,
  };

  const allStoresToHydrate = React.useMemo(
    () => [
      useAlboFornitoriStore,
      useCompaniesSearchStore,
      useComponentsStore,
      useCPVStore,
      useDashboardStore,
      useDefaultStrategyStore,
      useListUsersStore,
      useMapsStore,
      useRegisterStore,
      useTabStore,
      useTaskManagementStore,
      useTenderAwardsSearchStore,
      useTenderAwardsStore,
      useTenderSearchStore,
      useTenderStrategyStore,
      useVademecumStore,
      useViewSupplierListNotice,
      useVersionChangeStore,
    ],
    []
  );

  useRefreshOnVersionChange();

  const areAllStoresHydrated = useAllStoresHydrated(allStoresToHydrate);

  return !areAllStoresHydrated ? ( // screen spinners translate within the component
    <ScreenSpinner copy="Loading Tenders Club..." />
  ) : (
    <AuthContext.Provider value={value}>
      {forbidden ? (
        <div className="d-flex tc-screen-filling-message align-items-center justify-content-center tc-text-muted">
          <TendersClubLogo size="normal" colour={isDark ? "light" : "dark"} />
          <div className="heading">{i18n.t("Not Allowed")}</div>
          <div className="body ">
            {i18n.t(
              "You are not allowed to view this content. This is likely due to your subscription level being insufficient."
            )}
            {i18n.t(
              "If your trial expired or you recently canceled your subscription, you will need to re-subscribe before being allowed access."
            )}
          </div>
          <div className="d-flex">
            <Button
              onClick={() => {
                setTimeout(() => {
                  setForbidden(false);
                }, 200);
                navigate(`/${i18n.language.slice(0, 2)}/user_preferences`);
              }}
              color="primary"
              className="button-primary me-2"
            >
              {i18n.t("Go to settings")}
            </Button>
            <Button
              onClick={() => {
                setTimeout(() => {
                  setForbidden(false);
                }, 200);
                auth.signout();
              }}
              className="button-primary"
            >
              {i18n.t("Logout")}
            </Button>
          </div>
        </div>
      ) : unauthorised ? (
        <div className="d-flex tc-screen-filling-message align-items-center justify-content-center tc-text-muted">
          <TendersClubLogo size="normal" colour={isDark ? "light" : "dark"} />
          <div className="heading">{i18n.t("Session Expired")}</div>
          <div className="body">{i18n.t("Your login has expired. Please try to login again.")}</div>
          <Button
            onClick={() => {
              setTimeout(() => {
                setUnauthorised(false);
              }, 200);
              navigate(`/${i18n.language.slice(0, 2)}/login`);
            }}
            className="button-primary"
          >
            {i18n.t("Login")}
          </Button>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
}

export function RequireAuth({ children }) {
  devDebug("RequireAuth -> rendering");
  let location = useLocation();

  const [userID] = useAuthStore((state) => [state?.user?.id]);

  if (!userID) {
    return <Navigate to={`/${i18n.language.slice(0, 2)}/login`} state={{ from: location }} replace />;
  }

  return children;
}

export function RequireAdmin({ children }) {
  devDebug("RequireAdmin -> rendering");
  let location = useLocation();

  const [is_superuser] = useAuthStore((state) => [state?.user?.is_superuser]);

  if (!is_superuser) {
    return <Navigate to={`/${i18n.language.slice(0, 2)}`} state={{ from: location }} replace />;
  }

  return children;
}
